import _ from 'lodash';
import DataTypes from '../dataTypes';
import { getColumnDataPath } from '../data/columnData';
// import { getComparatorForColumn } from './comparators';

/**
 * Is data for column sorted by display value or actual value
 * @param column Column to check how data is sorted
 * @returns {boolean} True if searching by actual value, false if searching by
 *                    display value.
 */
function isSortByActualValue(column) {
  // Sort dates by the actual value (e.g. 2020-01-20T12:34:00Z) instead of the
  // display value (e.g. 20/01/2020).
  if (column.dataType === DataTypes.Date) {
    return true;
  }
  // By default search by display value
  return false;
}

/**
 * Get the data field to sort on. It supports columns showing translatable data.
 *
 * @param column Column to get
 * @param language User's active language
 * @returns {string} The data field (e.g. itemNumber and info.SE-sv.description).
 */
function getSortByDataField(column, language) {
  if (isSortByActualValue(column)) {
    const path = getColumnDataPath(column, language);
    if (column.path !== undefined) {
      if (column.path === 'root') {
        return path;
      }
    }
    return `data.${path}`;
  }
  return column.name;
}

/**
 * Sort data in a the table according to the sorting instructions.
 * @param data Data in table (on table data format, NOT raw data)
 * @param sorting Array with sorting instructions consisting of columns and
 *                directions.
 * @param columns Columns in the table
 * @param language User's active language
 * @returns {Array|*} The sorted table data
 */
// eslint-disable-next-line import/prefer-default-export
export function sortData(data = [], sorting = [], columns, language) {
  if (sorting.length > 1) {
    console.warn(
      'Multi column sorting is not supported. Only first column is considered.'
    );
  }
  if (sorting.length === 0) {
    return data;
  }
  const sortByColumnName = sorting[0].columnName;
  const sortDirection = sorting[0].direction;
  const sortByColumn = columns.filter(
    column => column.name === sortByColumnName
  );
  if (sortByColumn.length === 0) {
    console.warn(
      `Unable to find column with name "${sortByColumnName}". Unable to sort the dataset.`
    );
    return data;
  }
  const sortByDataPath = getSortByDataField(sortByColumn[0], language);

  if (!sortByDataPath) {
    console.warn(
      `dataField / calculateCellValue not specified for column with name ${sortByColumnName}. Unable to sort the table data.`
    );
    return data;
  }

  // TODO Investigate if comparators are needed
  // const comparator = getComparatorForColumn(sortByColumn[0]);
  // const sortedData = data.sort(object => {
  //   return object.get(sortByDataField);
  // }, comparator);
  console.log(sortByDataPath);
  const sortedData = _.sortBy(data, [sortByDataPath]);

  return sortDirection === 'asc' ? sortedData : sortedData.reverse();
}
